import Company from "@/modules/msd/company/common/service/Company";
import Mail from "@/modules/inc/mail/service/Mail";
import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";
import Inb from "@/modules/inb/service/Inb";

export default  {
    data: () => ({
        collective: false,

        attach: {
            visible: false,
            data   : null
        },

        drag: {
            notAllowed: false,
            message   : null
        },
    }),

    computed: {
        complainReasonAllowed () {
            return this.current.status.id === 31 || this.current.status.id === 32 || (this.data.complaintreason && this.data.complaintreason.length > 0);
        },
    },

    methods: {
        onSendStampMail(documents) {
            console.log("onSendStampMail", documents)
            const roles = [ Company.roles.customer ];
            Mail.initialize(
                this.incident.sites,
                this.index,
                this.data,
                this.current,
                this.incident,
                this.step,
                null,
                roles
            ).then(mail => {
                mail.template = 1;
                mail.attachments = documents;
                mail.callback = this.mailSended;
                this.$emit ("sendmail", mail);
            });
        },

        mailSended () {
            if (this.collective) {
                this.data.sendDate = Core.format.date.toJson(Core.format.today());
            } else {
                this.data.sendDate = Core.format.date.toJson(Core.format.today());
                this.current.sendDate = Core.format.date.toJson(Core.format.today());
                this.current.status = this.step.status.find(s => s.id === Inc.status.terminated)
            }

            this.save( );
        },

        onStamped () {
            this.data.verficationDate = Core.format.date.toJson(Core.format.today());
            this.save();
            this.$bus.$emit(Inc.events.journal);
        },

        /**
         * Checks whether a message can be attached to the current processing step.
         * @param dragData the message
         * @return true, if the message can be attached to the step.
         */
        onAcceptType (dragData) {
            if (!(dragData instanceof Object) || dragData.type === "dms-document") {
                return;
            }

            const accept = Inc.clipboard.accept(dragData, this.incident, [{
                message : "INVOICE",
                incident: null
            }, {
                message : "ORDER",
                incident: null
            },{
                message : "INVOICEREMINDER",
                incident: null
            }, {
                message : "DEFAULT",
                incident: null
            }, {
                message: "ORDER",
                incident: null
            }, {
                message: "WORKREPORT",
                incident: null
            }, {
                message: "IMAGE",
                incident: null
            },{
                message: "CORRESPONDENCE",
                incident: null
            },
            ], false, false);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            return accept.valid;
        },

        onDragend () {
            this.drag.notAllowed = false;
        },

        /**
         * Attaches a message to the processing step.
         * @param event the drag'n drop element that contains the message,
         */
        onDrop (event) {
            console.log("invoice on drop", event)
            const overwrite = this.overwritesData(event.data.data);
            console.log("overwrite ", overwrite)
            if (overwrite) {
                this.attach.data = event.data.data;
                this.attach.visible = true;
            } else {
                this.attachMessage(true, event.data.data);
            }
        },

        onAttach (event) {
            this.attachMessage(event.overwrite, event.data);
        },

        onAttachCancel () {
            this.attach.visible = false;
        },

        async getMail () {
            let company = null;
            if (this.index === 0) {
                company = null;
            } else {
                company = this.index === 1 ? this.previous.manufacturer : this.previous.bids[0].manufacturer;
            }

            return Mail.initialize(this.incident.sites, this.index, this.data, this.current, this.incident, this.step, company);
        },

        overwritesData () {
            if (this.collective) {
                return !!this.data.ordernumber || !!this.data.invoicenumber  || !!this.data.invoiceDate || !!this.data.item.amount.net;
            } else {
                return !!this.data.ordernumber || !!this.current.invoicenumber  || !!this.current.invoiceDate || !!this.current.item_1.amount.net;
            }
        },

        attachMessage (overwrite, data) {
            Inb.attach(this, data.id, this.incident.id, this.step, null, overwrite,(message) => {
                this.$emit("refresh", message);
            }).then(() => {});
        },
    }
}